export const getStatusTheme = (status = "") => {
  const normalized = status.toLowerCase();

  const colorMap = {
    pending: "bg-yellow-50 text-yellow-700 border-yellow-300",
    verified: "bg-teal-50 text-teal-700 border-teal-300",
    assigned: "bg-orange-50 text-orange-700 border-orange-300",
    confirmed: "bg-sky-50 text-sky-700 border-sky-300",
    ongoing: "bg-blue-50 text-blue-700 border-blue-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    cancelled: "bg-red-50 text-red-600 border-red-200",
    rescheduled: "bg-purple-50 text-purple-700 border-purple-200",
  };

  const labelMap = {
    pending: "Pending",
    verified: "Verified",
    assigned: "Assigned",
    confirmed: "Confirmed",
    ongoing: "Ongoing",
    completed: "Completed",
    cancelled: "Cancelled",
    rescheduled: "Rescheduled",
  };

  return {
    label: labelMap[normalized] || "Unknown",
    badge: colorMap[normalized] || "bg-gray-100 text-gray-500 border-gray-200",
  };
};

const StatusBadge = ({ status, className = "" }) => {
  const { label, badge } = getStatusTheme(status);

  return (
    <span
      className={`inline-flex items-center justify-center w-24 px-2.5 py-1 whitespace-nowrap rounded-full text-xs font-medium border text-center ${badge} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;

// const getStatusTheme = (status = "") => {
//   const normalized = status.toLowerCase();

//   const colorMap = {
//     pending: "bg-yellow-50 text-yellow-700 border-yellow-300",
//     confirmed: "bg-sky-50 text-sky-700 border-sky-300",
//     ongoing: "bg-blue-50 text-blue-700 border-blue-200",
//     completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
//     cancelled: "bg-red-50 text-red-600 border-red-200",
//     rescheduled: "bg-purple-50 text-purple-700 border-purple-200",
//   };

//   return {
//     label: normalized
//       ? normalized.charAt(0).toUpperCase() + normalized.slice(1)
//       : "Unknown",
//     badge: colorMap[normalized] || "bg-gray-100 text-gray-500 border-gray-200",
//   };
// };
